import {
	conversationActions,
	getConversationKey,
	NEW_CONVERSATION_ID,
	selectConversationByKey,
	setRecipientValid,
	setSelectedConversationKey,
	setSelectedMessage,
} from "@somewear/messaging";
import Paths from "@web/common/Paths";
import { createBrowserHistory } from "history";
import { Action } from "redux";
import { combineEpics, type Epic } from "redux-observable";
import { EMPTY, filter } from "rxjs";
import { mergeMap } from "rxjs/operators";

import { toggleSidebar } from "../app/appSlice";
import { sortConversationsDesc } from "./messagingSelectors";

const history = createBrowserHistory();

export const selectConversationEpic: Epic<Action<unknown>> = (action$, state$) =>
	action$.pipe(
		filter(
			(action) =>
				conversationActions.selectConversation.request.match(action) ||
				conversationActions.create.fulfilled.match(action),
		),
		mergeMap((action) => {
			let conversationKey: string | undefined;

			if (conversationActions.selectConversation.request.match(action)) {
				conversationKey = action.payload.data;
			} else if (conversationActions.create.fulfilled.match(action)) {
				conversationKey = getConversationKey({
					participantId: action.payload.data.conversation?.participantId,
				});
			}

			const conversation = selectConversationByKey(state$.value, conversationKey ?? "");

			if (!conversation) {
				conversationKey = getConversationKey(sortConversationsDesc(state$.value).first());
			}

			if (conversationKey) {
				history.push(Paths.Conversations + "/" + conversationKey);

				return [
					setSelectedConversationKey(conversationKey),
					setSelectedMessage(undefined),
					setRecipientValid({ valid: true }),
					toggleSidebar(),
				];
			}

			return EMPTY;
		}),
	);

export const newConversationEpic: Epic<Action<unknown>> = (action$, state$) =>
	action$.pipe(
		filter(conversationActions.new.match),
		mergeMap(() => {
			history.push(Paths.Conversations + "/" + NEW_CONVERSATION_ID);
			return EMPTY;
		}),
	);

export const onConversationDeleteEpic: Epic<any, any, any> = (action$, state$) =>
	action$.pipe(
		filter(conversationActions.delete.fulfilled.match),
		mergeMap(() => {
			const conversationPreviews = sortConversationsDesc(state$.value);
			const firstConversationKey = getConversationKey(conversationPreviews.first());

			if (firstConversationKey) {
				return [
					conversationActions.selectConversation.request({ data: firstConversationKey }),
				];
			}

			return EMPTY;
		}),
	);

export const webMessagingEpics = combineEpics<any, any, any>(
	selectConversationEpic,
	onConversationDeleteEpic,
	newConversationEpic,
);
